import { DEFAULT_COUNT_ON_PAGE } from '@shared/ui/pagination/constants';
import { FeedbackSubjectListDataRequest } from '../api/feedback-types';

export const DEFAULT_FEEDBACK_SUBJECTS_LIST_PARAMETERS: FeedbackSubjectListDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
};
